/**
 * Suppress WebSocket connection warnings from Pusher
 * This filters out browser-native WebSocket error messages
 */

// Store original console methods
const originalError = console.error;
const originalWarn = console.warn;

// List of patterns to suppress
const suppressPatterns = [
  /WebSocket connection.*failed/i,
  /WebSocket is closed before the connection is established/i,
  /transport_connection\.ts/i,
  /pusher\.com/i,
];

// Check if message should be suppressed
const shouldSuppress = (args) => {
  const message = args.join(' ');
  return suppressPatterns.some(pattern => pattern.test(message));
};

// Override console.error
console.error = (...args) => {
  if (!shouldSuppress(args)) {
    originalError.apply(console, args);
  }
};

// Override console.warn
console.warn = (...args) => {
  if (!shouldSuppress(args)) {
    originalWarn.apply(console, args);
  }
};

export default {
  restore: () => {
    console.error = originalError;
    console.warn = originalWarn;
  }
};
